import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toISO = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const localToday = () => toISO(new Date());
const uk = (v) => (v ? new Date(`${v.slice(0, 10)}T00:00:00`).toLocaleDateString("en-GB") : "");

// UK-format calendar date picker; value/onChange use "YYYY-MM-DD" ("" when empty).
export function DateField({ value, onChange, testId, placeholder = "Pick a date" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value.slice(0, 10)}T00:00:00`) : undefined;
  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId}
            className="flex-1 flex items-center gap-2 bg-[#091E16] border border-white/15 hover:border-brass rounded-lg px-3 py-2 text-sm text-left">
            <CalendarDays className="w-3.5 h-3.5 text-brass" />
            <span className={value ? "text-white" : "text-emerald-100/40"}>{value ? uk(value) : placeholder}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-[#0B241B] border-white/10 z-[70]" align="start">
          <Calendar mode="single" weekStartsOn={1} selected={selected} defaultMonth={selected}
            onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }} className="text-white" />
        </PopoverContent>
      </Popover>
      {value && <button type="button" onClick={() => onChange("")} data-testid={testId ? `${testId}-clear` : undefined} className="p-1.5 text-emerald-100/40 hover:text-white"><X className="w-3.5 h-3.5" /></button>}
    </div>
  );
}
